import { getUrlParams } from 'widgets/toolbox/util';
/**
 * @description Extended Variation Swatch implementation
 * @param {ColorSwatch} ColorSwatch widget for extending
 * @returns {typeof HarmonyVariationSwatch} Harmony Variation Swatch class
 */
export default function (ColorSwatch) {
    /**
     * @class HarmonyVariationSwatch
     * @augments ColorSwatch
     */
    class HarmonyVariationSwatch extends ColorSwatch {
        selectVariationSwatch(option) {
            // not swatchable and disabled options should be unselected
            if (option && option.attr('aria-disabled') === 'true') {
                return;
            }
            if (!option.data('attrIsSelected')) {
                const gtmData = {
                    variation: []
                };

                const paramsArray = getUrlParams(option.data('attrUrl'));

                // eslint-disable-next-line no-restricted-syntax
                for (const key in paramsArray) {
                    if (key.indexOf('size') !== -1 || key.indexOf('vintage-year') !== -1) {
                        gtmData.variation.push(paramsArray[key]);
                    }
                }

                gtmData.variation = gtmData.variation.join('|');

                this.eventBus().emit('gtm.variation.click', gtmData);
            }

            super.selectColor(option);
        }
    }

    return HarmonyVariationSwatch;
}
